import React from 'react'
import { Button } from 'spa/member/components/v2/Button'
import { useIsMobile } from 'spa/member/hooks/v2/useScreenSize'
import parallelJournal from 'images/top/logo_parallel_journal.svg'
import freelanceBasics from 'images/top/helpful_info_freelance.svg'
import styles from './HelpfulInfoCard.module.scss'
import { HelpfulInformationCardItemProps } from './types'
import { responsiveValue } from 'spa/libs/utils/responsiveValue'

export const HelpfulInformationCardItem: React.FC<HelpfulInformationCardItemProps> = ({
  src,
  alt,
  description,
  buttonText,
  navigateTo,
  className
}) => {
  const isMobile = useIsMobile()

  const isExternalLink = () => {
    return navigateTo.startsWith('http')
  }

  const externalLinkAttributes = isExternalLink() ? {
    target: '_blank',
    rel: 'noopener noreferrer',
  } : {}

  return (
    <div
      className={`flex flex-col justify-center items-center bg-member-white-100 rounded-M all:w-full all:p-XL all:gap-L mobile:p-M mobile:gap-M ${className || ''}`}
      style={{
        minHeight: responsiveValue(isMobile, '260px', '299px'),
        boxShadow: '0px 16px 24px 0px #0000000D',
      }}
    >
      <div
        className={`flex items-center justify-center`}
        style={{ height: '80px' }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      </div>
      <p className={`text-XS tablet:text-S tablet:py-2XS text-member-gray-100 ${styles.contentText}`}>
        {Array.isArray(description)
          ? description.map((line, index) => <span style={{lineHeight: '1.75'}} key={index}>{line}<br /></span>)
          : <span style={{lineHeight: '1.75'}}>{description}</span>}
      </p>
      <a href={navigateTo} {...externalLinkAttributes}>
        <Button
          className={`${styles.button}`}
          buttonType={responsiveValue(isMobile, 'SMALL', 'DEFAULT')}
          kind="primary"
          link
        >
          {buttonText}
        </Button>
      </a>
    </div>
  );
};

export const StyledHelpfulInformationCard: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <div
      className={`flex flex-col w-full mobile:gap-S tablet:gap-XL ${styles.container}`}
      style={{
        flexDirection: responsiveValue(isMobile, 'column', 'row'),
      }}
    >
      <HelpfulInformationCardItem
        src={parallelJournal}
        alt="クラウドワークスが運営するブログ「パラレルジャーナル」"
        description={['クラウドワークスが運営するブログ。', '確定申告や営業力などフリーランス向けのお役立ち情報を発信しています。']}
        buttonText={
          <>
            パラレルジャーナル
            <span
              className="pl-2XS material-symbols-outlined"
              style={{
                fontSize: '87.5%',
                verticalAlign: 'middle',
              }}
            >
              ad_group
            </span>
          </>
        }
        navigateTo="https://crowdworks.jp/p-journal/"
      />
      <HelpfulInformationCardItem
        src={freelanceBasics}
        alt="フリーランスの基礎知識"
        description="フリーランスになるには、何が必要？各種申請、確定申告などフリーランスを始めるために必要な情報をまとめました。"
        buttonText={
          <>
            フリーランスの基礎知識を見る
          </>
        }
        navigateTo="/knowledge"
      />
    </div>
  )
}
